import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IPlot } from "@interfaces/IPlot";
import { GoogleMarkerService } from "@services/googleMarker.service";
import { VeriMarkerService } from "@services/veriMarker.service";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";

interface IVeriMapPlotBindings {

    veriMap: IVeriMapComponent;

    plot: IPlot;
    fit: boolean;
}

class VeriMapPlotComponentController implements angular.IComponentController, IVeriMapPlotBindings {
    veriMap: IVeriMapComponent;

    plot: IPlot;
    displayPlot: IPlot;
    fit: boolean;

    static $inject = ["veriMarkerService", "googleMarkerService"];

    constructor(
        private readonly veriMarkerService: VeriMarkerService,
        private readonly googleMarkerService: GoogleMarkerService) {
    }

    $onInit() { }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (onChangesObj["plot"]) {
            this.veriMap.mapInitialisedPromise.then(() => {
                this.updateDisplayPlot();
            });
        }
    }

    // ---------------------

    private updateDisplayPlot() {
        const options = this.veriMarkerService.createVeriMarkerOptions(this.plot);

        this.googleMarkerService.generateMarkerOptions(this.plot, options).then(options => {
            this.displayPlot = copy(this.plot);
            this.displayPlot.markerModel.options = options;
            this.fitMap(this.veriMap.getMap());
        });
    }

    private fitMap(map: google.maps.Map) {
        if (map == null || !this.fit) {
            return;
        }

        map.setZoom(12);
        map.setCenter({ lat: this.plot.Latitude, lng: this.plot.Longitude });
    }
}

export class VeriMapPlotComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            plot: "<",
            fit: "<"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapPlotComponentController;
        this.template = require("./veriMapPlot.html");
    }
}
